// тази функция чисти name параметъра от предхождащи ги числа, заградени в скоби
// т.е. "1) ФИНАНСОВ ОТЧЕТ ЗА ПЪРВО ТРИМЕСЕЧИЕ, 2019.pdf става"
// на "ФИНАНСОВ ОТЧЕТ ЗА ПЪРВО ТРИМЕСЕЧИЕ, 2019.pdf"
// Това се налага, защото липсва апи, което да връща в точно определен ред файловете,
// а трябваше бързо да реализирам начин, по който да може те да може да се подредят в ред, който
// ъплоудъра да указва.

// Така когаго се качат няколко файла в дадеда директория на сървъра,
// може името им да започва с 1), 2) ..... 10), така те ще се показват в този ред.
// В никакъв случай не е най-удачния начин за реализация, но понеже не беше разработено апи,
// трябваше да импровизирам бързо нещо.

export const formatNameToShow = name => {
  const nameArr = name.split(")");
  const firstItem = nameArr.shift();
  return !isNaN(firstItem) ? nameArr.join(")").trim() : name;
};



// WEBPACK FOOTER //
// ./src/functions/formatNameToShow.js